import { useSearchParams } from 'react-router-dom';
import { Tabs } from '@/design-system';
import { FinancialPoliciesSection } from './FinancialPoliciesSection';
import { GatewaysSection } from './GatewaysSection';

export function FinancialSection() {
  const [params, setParams] = useSearchParams();
  const tab = params.get('tab') === 'gateways' ? 'gateways' : 'policies';
  return <div className="space-y-6">
    <header><h2 className="text-xl font-semibold text-gray-900">Financeira</h2>
      <p className="mt-1 text-sm text-gray-500">Políticas financeiras e configurações dos meios de pagamento.</p></header>
    <Tabs label="Configurações financeiras" value={tab} onChange={(value) => setParams({ tab: value }, { replace: true })}
      tabs={[
        { value: 'policies', label: 'Políticas financeiras', content: <FinancialPoliciesSection /> },
        { value: 'gateways', label: 'Gateways de pagamento', content: <GatewaysSection /> },
      ]} />
  </div>;
}
